import ContextBreadcrumb from "@/contexts/Breadcrumb";
import { getArrayPath } from "@/utils/getArrayPath";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

interface ProviderBreadcrumb {
    children: React.ReactNode
}

export function BreadcrumbProvider({ children }: ProviderBreadcrumb) {
    const [paths, setPaths] = useState<string[] | null>(null);
    const navigation = useLocation();

    useEffect(() => {
        setPaths(getArrayPath(navigation?.pathname));
    }, [navigation?.pathname])

    return (
        <ContextBreadcrumb.Provider value={{ paths }}>
            {children}
        </ContextBreadcrumb.Provider>
    )
}